import { render, staticRenderFns } from "./StudentAssessmentScore.vue?vue&type=template&id=ede84602&scoped=true"
import script from "./StudentAssessmentScore.vue?vue&type=script&lang=js"
export * from "./StudentAssessmentScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede84602",
  null
  
)

export default component.exports